module.exports = __webpack_public_path__ + "34e8804de55fe1f0e0e9dcac18ace58e.svg";